import { MobileRichTextEditor } from 'features/mobile-rich-text-editor';

const PageMobileRichTextEditor = () => <MobileRichTextEditor />;

export default PageMobileRichTextEditor;
